import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';

@Component({
    selector: 'deliver-stop-overlay',
    templateUrl: './deliver-stop-overlay.component.html',
    styleUrls: ['./deliver-stop-overlay.component.scss'],
    standalone: false
})
export class DeliverStopOverlayComponent{
  @Output() public deliveryStopClosed: EventEmitter<boolean> = new EventEmitter()
}
